import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVerticalStepperCheckmark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_28684_619)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M9 13.2998L13.2679 18.2998L22 7.7998",
			stroke: "#48A600",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M24.5 14C24.5 19.799 19.799 24.5 14 24.5C8.20101 24.5 3.5 19.799 3.5 14C3.5 8.20101 8.20101 3.5 14 3.5C15.2272 3.5 16.4053 3.71054 17.5 4.09747",
			stroke: "#CACACA",
			strokeWidth: 1.75,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_28684_619",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 28,
			height: 28,
			fill: "white"
		})
	}) })]
});
export default SvgVerticalStepperCheckmark;
